import { render, staticRenderFns } from "./Saturn.vue?vue&type=template&id=50deea0c&"
import script from "./Saturn.vue?vue&type=script&lang=js&"
export * from "./Saturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports